var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewClockIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_247_11210)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.32268 14.411C5.90298 14.411 4.51515 13.99 3.33472 13.2012C2.15428 12.4125 1.23423 11.2914 0.690938 9.97979C0.147641 8.66816 0.00549024 7.22487 0.28246 5.83245C0.559431 4.44002 1.24308 3.161 2.24696 2.15712C3.25085 1.15324 4.52987 0.469587 5.92229 0.192617C7.31472 -0.0843535 8.758 0.0577977 10.0696 0.601094C11.3813 1.14439 12.5023 2.06443 13.2911 3.24487C14.0798 4.42531 14.5008 5.81313 14.5008 7.23283C14.4987 9.13594 13.7417 10.9605 12.396 12.3062C11.0503 13.6519 9.22578 14.4088 7.32268 14.411ZM7.32268 1.84923C6.2579 1.84923 5.21704 2.16497 4.33171 2.75653C3.44638 3.34809 2.75635 4.18889 2.34887 5.17262C1.9414 6.15634 1.83479 7.23881 2.04251 8.28312C2.25024 9.32744 2.76298 10.2867 3.51589 11.0396C4.2688 11.7925 5.22807 12.3053 6.27239 12.513C7.31671 12.7207 8.39917 12.6141 9.3829 12.2066C10.3666 11.7992 11.2074 11.1091 11.799 10.2238C12.3905 9.33848 12.7063 8.29761 12.7063 7.23283C12.7049 5.80545 12.1372 4.43694 11.1279 3.42762C10.1186 2.41831 8.75006 1.85065 7.32268 1.84923Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.3226 8.1297C7.08475 8.1297 6.85664 8.03517 6.68845 7.8669C6.52027 7.69863 6.42578 7.4704 6.42578 7.23243V3.64336C6.42578 3.40539 6.52027 3.17717 6.68845 3.0089C6.85664 2.84063 7.08475 2.74609 7.3226 2.74609C7.56045 2.74609 7.78856 2.84063 7.95674 3.0089C8.12493 3.17717 8.21941 3.40539 8.21941 3.64336V7.23243C8.21941 7.4704 8.12493 7.69863 7.95674 7.8669C7.78856 8.03517 7.56045 8.1297 7.3226 8.1297Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.21941 3.64336V7.23243C8.21941 7.4704 8.12493 7.69863 7.95674 7.8669C7.78856 8.03517 7.56045 8.1297 7.3226 8.1297C7.08475 8.1297 6.85664 8.03517 6.68845 7.8669C6.52027 7.69863 6.42578 7.4704 6.42578 7.23243V3.64336C6.42578 3.40539 6.52027 3.17717 6.68845 3.0089C6.85664 2.84063 7.08475 2.74609 7.3226 2.74609C7.56045 2.74609 7.78856 2.84063 7.95674 3.0089C8.12493 3.17717 8.21941 3.40539 8.21941 3.64336Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_247_11210"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14.3563,
    height: 14.3563,
    fill: "white",
    transform: "translate(0.140625 0.0556641)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewClockIcon);
export default __webpack_public_path__ + "static/media/newClockIcon.ad9b48c1680a7b7042561799fd43c968.svg";
export { ForwardRef as ReactComponent };